import { convertCase } from '@/utils';
import { getFormattedDate } from '@/utils/time';
import { hubDailyReportPageConfigMapper } from '@/constants/hubAdjustment/daily';
import { i18n } from '@/locales';
const getters = {
    // 상세 페이지의 타이틀을 위한 날짜 포멧팅 yyyyMMdd -> yyyy-MM-dd
    getterSelectedDetailDate: (state) => {
        const date = state.detailDate;
        if (!date) {
            return '';
        }
        const selectedDate = getFormattedDate(date, 'yyyyMMdd', 'yyyy-MM-dd');
        return selectedDate;
    },
    // 페이지의 타이틀을 위한 타입 이름
    getterSelectedTypeName: (state) => {
        const type = state.reportType;
        if (!type) {
            return '';
        }
        const selectedType = hubDailyReportPageConfigMapper[type].title;
        return selectedType;
    },
    // 페이지의 타이틀을 위한 칩
    getterSelectedChipInfo: (state) => {
        const type = state.reportType;
        if (!type) {
            return '';
        }
        const selectedType = hubDailyReportPageConfigMapper[type]?.chipInfo;
        return selectedType;
    },
    // api 조회를 위한 상점 유형
    getterStoreType: (state) => {
        const type = state.reportType;
        if (!type) {
            return undefined;
        }
        const selectedType = hubDailyReportPageConfigMapper[type]?.storeType;
        return selectedType;
    },
    // 내역 다운로드를 위한 파일명
    getterFileName: (state) => {
        const type = state.reportType;
        if (!type) {
            return undefined;
        }
        const currentTypeForLocale = convertCase(type, 'camel', 'snake');
        let filename = '';
        let { fromAt, toAt } = state.filterOption;
        let date = state.detailDate;
        if (date) {
            date = getFormattedDate(date, 'yyyyMMdd', 'MMdd');
            filename = i18n.t(`views.hub_adjustment_daily.file_name.${currentTypeForLocale}`, {
                date,
            });
            return filename;
        }
        if (fromAt && toAt) {
            fromAt = getFormattedDate(fromAt, 'yyyy-MM-dd', 'MMdd');
            toAt = getFormattedDate(toAt, 'yyyy-MM-dd', 'MMdd');
            filename = i18n.t(`views.hub_adjustment_daily.file_name.${currentTypeForLocale}`, {
                fromAt,
                toAt,
            });
            return filename;
        }
        return filename;
    },
};
export default getters;
